import { render, staticRenderFns } from "./matchRecordList.vue?vue&type=template&id=58364cc6&scoped=true&"
import script from "./matchRecordList.vue?vue&type=script&lang=js&"
export * from "./matchRecordList.vue?vue&type=script&lang=js&"
import style0 from "./matchRecordList.vue?vue&type=style&index=0&id=58364cc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58364cc6",
  null
  
)

export default component.exports